import React from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Main from "./pages/Main";
import Main_Eng from "./pages/Main_Eng";

import Personality from "./pages/Personality/Personality";
import PersonalityEng from "./pages/Personality/Eng_Personality/Personality.jsx";

import Project from "./pages/Project/Project";
import ProjectEng from "./pages/Project/Project_Eng/Project.jsx";

import Project_detail from "./pages/Project/detail/Project_detail";
import ProjectDetailEng from "./pages/Project/Project_Eng/detail/Project_detail.jsx";

import Resume from "./pages/Resume/Resume";
import ResumeEng from "./pages/Resume/Eng_Resume/Resume"

import Award from "./pages/Award/Award";
import AwardEng from "./pages/Award/AwardEng/Award.jsx"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/eng" element={<Main_Eng />} />

        <Route path="/resume" element={<Resume />} />
        <Route path="/resume-eng" element={<ResumeEng />} />

        <Route path="/project" element={<Project />} />
        <Route path="/project-detail/:itemId" element={<Project_detail />} />

        <Route path="/project-eng" element={<ProjectEng />} />
        <Route path="/project-detail-eng/:itemId" element={<ProjectDetailEng />} />

        <Route path="/award" element={<Award />} />
        <Route path="/award-eng" element={<AwardEng />} />

        <Route path="/personality" element={<Personality />} />
        <Route path="/personality-eng" element={<PersonalityEng />} />
      </Routes>
    </BrowserRouter>
  );
}


export default App;
